/* eslint-disable react/no-danger */
import { useHelp } from '@centecomm/portal-service-react';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { PageWrapper } from 'Shared/PageWrapper';
import { globalMessageActionCreators } from 'State';
import { LoadingContent } from 'Shared/PageElements';
import { useTranslation } from 'react-i18next';
import styles from './ProductDocumentationPage.module.css';

const ProductDocumentationPage = (): React.ReactElement => {
    const { t } = useTranslation(['core']);
    const { getHelpGuides } = useHelp();
    const dispatch = useDispatch();

    const [isLoaded, setIsLoaded] = React.useState<boolean>(false);
    const [helpGuidesContent, setHelpGuidesContent] = React.useState<string>();

    React.useEffect(() => {
        const getHelpGuidesContent = async () => {
            try {
                const helpGuides = await getHelpGuides();
                setHelpGuidesContent(helpGuides);
            } catch (error) {
                dispatch(globalMessageActionCreators.addErrorMessage(t('core:productDocumentationPage.error'), error));
            } finally {
                setIsLoaded(true);
            }
        };

        if (!isLoaded) {
            getHelpGuidesContent();
        }
    }, [isLoaded]);

    return (
        <PageWrapper pageTitle={t('core:productDocumentationPage.title')}>
            {!isLoaded && <LoadingContent />}
            {isLoaded && (
                <iframe
                    srcDoc={helpGuidesContent}
                    className={styles.HelpGuidesContent}
                    title={t('core:productDocumentationPage.title')}
                />
            )}
        </PageWrapper>
    );
};

export default ProductDocumentationPage;
